function Curacao({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1025)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M16 31.9997C21.25 31.9997 25.9093 29.4711 28.8268 25.5654H3.17322C6.09072 29.4711 10.75 31.9997 16 31.9997Z" fill="#0052B4"/>
  <path d="M32 16C32 7.1635 24.8365 0 16 0C7.1635 0 0 7.1635 0 16C0 17.8921 0.329313 19.707 0.93225 21.3918H31.0677C31.6707 19.707 32 17.8921 32 16Z" fill="#0052B4"/>
  <path d="M10.9514 10.2607L11.8147 12.9177H14.6087L12.3484 14.5601L13.2117 17.2172L10.9514 15.575L8.69106 17.2172L9.5545 14.5601L7.29419 12.9177H10.0881L10.9514 10.2607Z" fill="#F0F0F0"/>
  <path d="M6.15336 7.47852L6.67136 9.07277H8.34779L6.99161 10.0581L7.50961 11.6525L6.15336 10.6671L4.79717 11.6525L5.31523 10.0581L3.95911 9.07277H5.63548L6.15336 7.47852Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Curacao;
